export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'callcenter::sidebarCollapsed';

// Хранится только явное «свернуть». Всё остальное — отсутствующий ключ, мусор, недоступный
// storage — читается как «развёрнут»: умолчание обязано совпадать с тем, как десктоп выглядел
// до появления кнопки, иначе обновление молча поменяло бы раскладку у всех пользователей.
export const readSidebarCollapsed = () => {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const persistSidebarCollapsed = (collapsed) => {
  try {
    if (collapsed) {
      localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, 'true');
    } else {
      localStorage.removeItem(SIDEBAR_COLLAPSED_STORAGE_KEY);
    }
  } catch {
    // no-op for environments without localStorage access
  }
};
